import { loadImage } from '@forest/shared'
import type { Item, ItemBase } from '~/features/reward-flow/store'
import { m } from '~/paraglide/messages'
import type { GrantedContent } from '~/types/reward'
import { BIG_PRIZE_TREE_TYPE_GIDS } from './constants'

type GetMessage = (key: string) => string | null

const buildItem = async (
  content: GrantedContent,
  getMessage: GetMessage,
): Promise<ItemBase> => {
  const {
    title,
    bgAnimType,
    resultBgColor,
    resultTextGradient,
    isBigPrize = false,
  } = (() => {
    switch (content.type) {
      case 'coin':
        return {
          title: `${m.coin()} x${content.value}`,
          bgAnimType: 1 as const,
          resultBgColor: '#F6E085',
          resultTextGradient: 'linear-gradient(to right, #DC9907, #FED345)',
        }
      case 'gem':
        return {
          title: `${m.time_crystal()} x${content.value}`,
          bgAnimType: 2 as const,
          resultBgColor: '#7DDFEB',
          resultTextGradient: 'linear-gradient(to right, #4C57B3, #45C6FE)',
        }
      case 'tree_type':
        return {
          title: getMessage(content.title_key) ?? '',
          bgAnimType: 3 as const,
          resultBgColor: '#F8E69B',
          resultTextGradient: undefined,
          isBigPrize: BIG_PRIZE_TREE_TYPE_GIDS.includes(content.value),
        }
      case 'sound':
        return {
          // TODO:
          // title: m.new_sound_unlocked(),
          title: '',
          bgAnimType: 3 as const,
          resultBgColor: '#C8A2F8',
          resultTextGradient: undefined,
        }
      case 'land_skin':
        return {
          title: getMessage(content.title_key) ?? '',
          bgAnimType: 3 as const,
          resultBgColor: '#A8E6CF',
          resultTextGradient: undefined,
        }
      case 'game_pass':
        return {
          title: `Game Pass`,
          bgAnimType: 3 as const,
          resultBgColor: '#F8E69B',
          resultTextGradient: undefined,
        }
      case 'sunshine':
        return {
          title: `${m.sunshine_exlixir()} x${content.value}`,
          bgAnimType: 3 as const,
          resultBgColor: '#F6E085',
          resultTextGradient: undefined,
        }
    }
  })()

  await loadImage(content.icon_image_url)

  return {
    title,
    icon: content.icon_image_url,
    label:
      content.type === 'tree_type' ||
      content.type === 'land_skin' ||
      content.type === 'sound'
        ? ''
        : `x${content.value}`,
    bgAnimType,
    resultBgColor,
    resultTextGradient,
    type: content.type,
    value: content.value,
    isBigPrize,
  }
}

export async function convertGrantedContentsToRewardItems(
  grantedContents: GrantedContent[],
  getMessage: GetMessage,
): Promise<Item[]> {
  return Promise.all(
    grantedContents.map(async (content) => ({
      ...(await buildItem(content, getMessage)),
      originalItem: undefined,
    })),
  )
}
